module.exports = __webpack_public_path__ + "img/3_2.5fae1855.png";